import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from 'react-select';

import "./AddMissingMealOrders.css"

import { getAllUsers } from "../../../../actions/userActions";
import { getMeals } from "../../../../actions/mealActions";
import { addMissingMealOrders } from "../../../../actions/mealOrderActions";

class AddMissingMealOrders extends React.Component {
    constructor(props) {
        super(props);

        this.initialState = {
            orders: {},
            errors: []
        };
        this.state = this.initialState;
    }

    componentDidMount() {
        this.props.getAllUsers();
        this.props.getMeals();
    }

    onRowUpdate = (orderID, value) => {
        if (orderID !== null) this.setState({ orders: { ...this.state.orders, [orderID]: { ...this.state.orders[orderID], userID: value.value.userID, user: value.value } } });
        else this.setState({ orders: { ...this.state.orders, [Math.max.apply(null, [-1, ...Object.keys(this.state.orders)]) + 1]: { userID: value.value.userID, user: value.value, meals: {} } } });
    };

    onMealUpdate = (orderID, mealID, value) => {
        const meals = { ...this.state.orders[orderID].meals, [value.value.mealID]: value.value.description };
        if (mealID !== null) meals[mealID] = null;
        this.setState({ orders: { ...this.state.orders, [orderID]: { ...this.state.orders[orderID], meals }} });
    };

    onRowDelete = (orderID) => this.setState({ orders: Object.fromEntries(Object.entries(this.state.orders).filter(([key]) => key !== orderID)) });

    onMealDelete = (orderID, mealID) => {
        this.setState({ orders: {
            ...this.state.orders,
            [orderID]: {
                ...this.state.orders[orderID],
                meals: {
                    ...this.state.orders[orderID].meals,
                    [mealID]: null
                }
            }
        }});
    };

    onChangesApply = () => {
        const formValues = {
            orders: Object.entries(this.state.orders).map(([ orderID, order ]) => ({
                tmpOrderID: orderID,
                userID: order.userID,
                mealIDs: Object.keys(order.meals).filter(mealID => order.meals[mealID])
            }))
        };
        this.props.addMissingMealOrders(formValues, this.onError);
    };

    onError = ({ data }) => {
        this.setState({ errors: data.error });
    };

    renderError = error => {
        return error ? (
            <div className="ui error message">
                {error.message.map((line, index) => <p key={index}>{line}</p>)}
            </div>
        ) : null;
    };

    renderOrders = () => Object.keys(this.state.orders).map(key => {
        return (
            <div key={key} className="ui segment">
                {this.renderOrder(key, this.state.orders[key])}
            </div>
        );
    });

    renderOrder = (orderID, order) => {
        const orderErrors = {
            userID: this.state.errors.filter(err => err.field === "userID" && err.orderID === +orderID)[0],
            mealIDs: this.state.errors.filter(err => err.field === "mealIDs" && err.orderID === +orderID)[0],
            meals: this.state.errors.filter(err => err.field === "mealID" && err.orderID === +orderID).reduce((mealsDict, e) => {
                if (!mealsDict[e.mealID]) mealsDict[e.mealID] = e;
                return mealsDict;
            }, {})
        };

        return (
            <React.Fragment>
                <div className="content">
                    <b>Użytkownik:</b>
                    <Select
                        value={{ label: `${order.user.lname} ${order.user.fname}`, value: order.user }}
                        onChange={value => this.onRowUpdate(orderID, value)}
                        options={[...this.props.usersList.map(u => { return { label: `${u.lname} ${u.fname}`, value: u } })]}
                        placeholder="Użytkownik"
                        noOptionsMessage={() => "Nie znaleziono użytkowników"}
                        maxMenuHeight="400px"
                    />
                </div>
                {this.renderError(orderErrors.userID)}
                <div className="ui divider" />
                <div className="content"><b>Zamówione pozycje:</b></div>
                <div className="ui grid">
                    {this.renderMeals(orderID, order.meals, orderErrors.meals)}
                    <div className="row">
                        <div className="fourteen wide column">
                            <Select
                                value={{ label: "Dodaj pozycję...", value: null }}
                                onChange={value => this.onMealUpdate(orderID, null, value)}
                                options={[...this.props.mealsList.map(m => { return { label: m.description, value: m } })]}
                                placeholder="Posiłek"
                                noOptionsMessage={() => "Nie znaleziono posiłków"}
                                maxMenuHeight="400px"
                            />
                        </div>
                    </div>
                </div>
                {this.renderError(orderErrors.mealIDs)}
                <div className="ui divider" />
                <button className="ui button" onClick={() => this.onRowDelete(orderID)}>Usuń</button>
            </React.Fragment>
        )
    };

    renderMeals = (orderID, meals, mealsErrors) => Object.keys(meals).map(mealID => {
        return (meals[mealID] ? (
            <div className="row" key={mealID}>
                <div className="fourteen wide column">
                    <Select
                        value={{ label: meals[mealID], value: { mealID, description: meals[mealID] } }}
                        onChange={value => this.onMealUpdate(orderID, mealID, value)}
                        options={[...this.props.mealsList.map(m => { return { label: m.description, value: m } })]}
                        placeholder="Posiłek"
                        noOptionsMessage={() => "Nie znaleziono posiłków"}
                        maxMenuHeight="400px"
                    />
                    {this.renderError(mealsErrors[mealID])}
                </div>
                <div className="two wide column">
                    <button className="ui button" onClick={() => this.onMealDelete(orderID, mealID)}>Usuń</button>
                </div>
            </div>
        ) : <React.Fragment key={mealID}></React.Fragment>);
    });

    render() {
        return (
            <React.Fragment>
                <div className="add-missing-meal-orders-component ui container">
                    <div className={`ui ${this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? "four" : "two"} item menu`}>
                        <Link to="/meal-reservations/my" className="item">
                            <div className="content">Rezerwacje</div>
                        </Link>
                        <Link to="/meal-orders/my" className="item">
                            <div className="content">Moje zamówienia</div>
                        </Link>
                        {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                            <React.Fragment>
                                <Link to="/meal-orders/today" className="active item">
                                    <div className="content">Korekty zamówień</div>
                                </Link>
                                <Link to="/meal-orders/reports" className="item">
                                    <div className="content">Zestawienia</div>
                                </Link>
                            </React.Fragment>
                        ) : null}
                    </div>
                    {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                        <div className="ui two item menu">
                            <Link to="/meal-orders/today" className="item">
                                <div className="content">Korekta statusów zamówień</div>
                            </Link>
                            <Link to="/meal-orders/missing" className="active item">
                                <div className="content">Dodanie brakujących zamówień</div>
                            </Link>
                        </div>
                    ) : null}
                    <div className="ui divider" />
                    <div className="ui container">
                        {this.renderOrders()}
                        <Select
                            value={{ label: "Dodaj brakujące zamówienie...", value: null }}
                            onChange={value => this.onRowUpdate(null, value)}
                            options={[...this.props.usersList.map(u => { return { label: `${u.lname} ${u.fname}`, value: u } })]}
                            placeholder="Użytkownik"
                            noOptionsMessage={() => "Nie znaleziono użytkowników"}
                            maxMenuHeight="400px"
                        />
                        <div className="ui divider" />
                        {Object.keys(this.state.orders).length ? (
                            <React.Fragment>
                                <button className="ui primary button" onClick={this.onChangesApply}>Zatwierdź</button>
                                <button className="ui button" onClick={() => this.setState(this.initialState)}>Anuluj</button>
                            </React.Fragment>
                        ) : null}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    usersList: state.user.list,
    mealsList: state.meal.list
});

export default connect(mapStateToProps, { getAllUsers, getMeals, addMissingMealOrders })(AddMissingMealOrders);